import useTranslation from "../../../i18n/useTranslation";
import {GlobalStyles} from "../../../constants/styles";

export default function DownloadApp() {
    const {t} = useTranslation();

    return (
        <div className="row mt-5 text-center justify-content-center">
            <div className="col-md-8">
                <div
                    className="card p-4 rounded"
                    style={{
                        backgroundColor: "#1f1f2e",
                        color: "#ffffff",
                    }}
                >
                    <h3 style={{color: GlobalStyles.colors.canary}}>{t('defaultHome.download.title')}</h3>
                    <p>{t('defaultHome.download.subtitle')}</p>
                    <div className="d-flex justify-content-center flex-wrap gap-3 mt-3">
                        {/* App Store */}
                        <a
                            href="https://apps.apple.com/ca/app/kbolasports/id6743017131" // Replace with real App Store link
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mr-5"
                        >
                            <img
                                src="/dist/img/ios-white-badge.svg"
                                alt="Download on the App Store"
                                style={{height: 50}}
                            />
                        </a>

                        {/* Google Play */}
                        <a
                            href="https://play.google.com/store/apps/details?id=com.alejandromf27.kbolasportsmobile" // Replace with real Play Store link
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/dist/img/google-badge.png"
                                alt="Get it on Google Play"
                                style={{height: 50}}
                            />
                        </a>
                    </div>

                    {/* QR Code */}
                    <div className="mt-4">
                        <p style={{color: "#8d929d"}}>{t('defaultHome.download.scanLabel')}</p>
                        <img
                            src="/dist/img/app-qr.png" // Replace with your QR image
                            alt="AngeonX Sports QR"
                            style={{width: 120}}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
